import type { JSX } from 'react'

// for the correct size of this icon, you must additionally set the size in the place of use for <Icon size={IconSocialSizes.googlePlay}
export const GooglePlayIcon = (): JSX.Element => (
  <use href='#googlePlayIcon' height='28px' width='96px' />
)
